import "./App.css";
import "./index.css";
import { useEffect} from "react";
import Sidebar from "@/components/Sidebar/Sidebar";
import Navbar from "@/components/Navbar/TopNavBar";
import AppRouter from "./routes/AppRouter";
import { Box } from "@mui/material";
import { BrowserRouter } from "react-router-dom";
import { useLocation } from "react-router-dom";
import ROUTES from "./config/routes";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { TenantProvider } from "./components/Navbar/TenantContext";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import useAuthStore from "@/store/useAuthStore";
import useSidebarStore from "./store/useSidebarStore";
import useThemeStore from "./store/useThemeStore";

const queryClient = new QueryClient();

function AppContent() {
  const location = useLocation();
  const isCollapsed = useSidebarStore((state) => state.isCollapsed);

  const isLoginPage = location.pathname === ROUTES.LOGIN;
  const isForgotPasswordPage = location.pathname === ROUTES.FORGOTPASSWORD;
  const isResetPassword = location.pathname === ROUTES.RESETPASSWORD;

  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const role = useAuthStore((state) => state.role);

  console.log("AppContent Render - isAuthenticated:", isAuthenticated);
  console.log("AppContent Render - role:", role);

  const showSidebarAndNavbar = !isLoginPage && !isForgotPasswordPage && !isResetPassword;
  const { theme } = useThemeStore();

  useEffect(() => {
    useThemeStore.getState().initTheme();
  }, []);

  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
    document.documentElement.setAttribute("data-theme", theme);
  }, [theme]);

  return (
    <div className="flex min-h-screen bg-background text-foreground" style={{
      backgroundColor: 'var(--color-bg)',
      color: 'var(--color-text)',
      transition: 'background-color 0.3s ease, color 0.3s ease'
    }}>
      <ToastContainer position="top-right" autoClose={3000} />
      {showSidebarAndNavbar && <Sidebar />}

      <div
        className={`flex-1 min-w-0 transition-all duration-300 ${
          showSidebarAndNavbar
            ? isCollapsed
              ? "md:ml-20 ml-0"
              : "md:ml-64 ml-0"
            : "ml-0"
        }`}
      >
        <Box className="h-screen overflow-auto">
          {showSidebarAndNavbar && <Navbar />}
          <AppRouter />
        </Box>
      </div>
    </div>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <TenantProvider>
          <BrowserRouter>
            <AppContent />
          </BrowserRouter>
        </TenantProvider>
      </LocalizationProvider>
    </QueryClientProvider>
  );
}

export default App;
